import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid } from '@chakra-ui/react';
import { SelectTabs } from '../../inputs';
import { JsFieldInspector, JsFieldName } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
/**xw
 * Component renders "/schemas/jsf-tabs" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is string or number.
 */
const TabsJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const options = props.schema?.oneOf?.map((opt) => {
        const schemaOpt = opt;
        return { value: schemaOpt.const, label: schemaOpt.title, readonly: schemaOpt.readOnly };
    }) ?? [];
    const handleChange = (value) => {
        props.onChange(value);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['string', 'number'], children: _jsxs(Grid, { "data-testid": "TabsJsField-test", "data-name": props.name, gridTemplateColumns: "minmax(0, 180px) 1fr", alignItems: "center", gap: "4px", children: [_jsx(JsFieldName, { name: props.schema.title }), _jsx(SelectTabs, { options: options, value: props.formData, onChange: (newValue) => {
                        handleChange(newValue);
                    } })] }) }));
};
export const TabsJsField = TabsJsFieldFC;
//# sourceMappingURL=TabsJsField.js.map